var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-box",class:[_vm.type, _vm.size]},[(!_vm.title && _vm.type !== 'success')?_c('strong',[_vm._v(_vm._s(_vm.boxTitle)+" : ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }